import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelperText } from '@components/Styled';
import { AuxiliaryDataContainer } from './SummaryCard.style';
const AuxiliaryItem = ({ title, helper, data, dataColor }) => (_jsxs(AuxiliaryDataContainer, { children: [_jsxs("div", { children: [_jsx(HelperText, { level: "3", children: title }), helper && (_jsx(HelperText, { children: helper }))] }), _jsx("div", { children: _jsx(HelperText, { style: { color: dataColor }, children: data }) })] }));
export default AuxiliaryItem;
